import React from 'react';
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";

interface TypographySaveButtonProps {
  onSave: () => void;
  saving: boolean;
  uploading: boolean;
  fontSource: 'google' | 'custom';
  selectedGoogleFont: string;
  customFontFile: File | null;
  config: any;
}

export function TypographySaveButton({
  onSave,
  saving,
  uploading,
  fontSource,
  selectedGoogleFont,
  customFontFile,
  config
}: TypographySaveButtonProps) {
  console.log('🔄 [TypographySaveButton] Component rendering!', { saving, uploading, disabled: saving || uploading });
  return (
    <div className="flex justify-end">
      <Button 
        onClick={() => {
          console.log('🚨 BUTTON CLICKED! Basic test');
          console.log('🚨 Button state:', { saving, uploading, disabled: saving || uploading });
          onSave();
        }} 
        disabled={saving || uploading}
        className="flex items-center gap-2"
        type="button"
      >
        <Save className="h-4 w-4" />
        Save Typography Settings
      </Button>
    </div>
  );
}